import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import classes from "./MeterBar.module.css"
import type { TMicLevel } from "./Visualizer"

interface IProps {
  /** RMS volume 0..1. Pass 0 when paused. */
  volume: number
  level: TMicLevel
}

export function MeterBar({ volume, level }: IProps): React.JSX.Element {
  const { i18n } = useLingui()
  const pct = level === "silent" ? 4 : Math.max(2, Math.min(100, volume * 200))
  const warning = level === "clipping"
  return (
    <meter
      className={classes.meter}
      data-warning={warning ? "true" : "false"}
      data-testid="recording-meter"
      aria-label={i18n._(msg`Mic level`)}
      min={0}
      max={100}
      value={Math.round(pct)}
    />
  )
}
